(() => {
  const init = (section) => {
    if (section.dataset.faqInit) return;
    section.dataset.faqInit = '1';

    // Accordion: toggle expanded state + reveal answer
    section.querySelectorAll('[data-faq-trigger]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-faq-item]');
        const answer = item && item.querySelector('[data-faq-answer]');
        if (!answer) return;
        const isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        if (isOpen) {
          answer.setAttribute('hidden', '');
        } else {
          answer.removeAttribute('hidden');
        }
      });
    });

    // Tabs: swap the visible question list.
    // ponytail: panels are inline in the markup; move to Liquid blocks when categories are editable.
    const tabs = section.querySelectorAll('[data-faq-tab]');
    const panels = section.querySelectorAll('[data-faq-panel]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const name = tab.dataset.faqTab;
        tabs.forEach((t) => {
          const on = t === tab;
          t.classList.toggle('oddit-section-faq__tab--active', on);
          t.setAttribute('aria-selected', String(on));
        });
        panels.forEach((panel) => {
          panel.toggleAttribute('hidden', panel.dataset.faqPanel !== name);
        });
      });
    });
  };

  document.querySelectorAll('.oddit-section-faq').forEach(init);
})();
